<button
  [attr.data-test]="node?.uid"
  class="btn btn-primary toggle-btn"
  [attr.tabindex]="0"
  [attr.aria-haspopup]="true"
  [attr.aria-expanded]="false"
  [attr.aria-label]="node?.title"
  (click)="toggleOpen($any($event))"
  (mouseenter)="onMouseEnter($event)"
  (keydown.space)="toggleOpen($any($event))"
  (keydown.esc)="back()"
  [attr.aria-label]="node?.title"
>
  {{ node?.title }}
  <mat-icon svgIcon="arrow-down"></mat-icon>
</button>
@if (isOpen) {
  <nav
    [attr.data-test]="node?.uid + '--nav'"
    [attr.aria-label]="navAriaLabel" class="my-account--dropdown" @fadeInContentByHeightOpacity
  >
    <ul [attr.data-test]="node?.uid + '--list'">
      <header class="my-account--header" [attr.data-test]="node?.uid + '--header'">
        <cx-page-slot position="SiteLogo" [attr.data-test]="node?.uid + '--logo'"></cx-page-slot>
        <button
          [attr.data-test]="node?.uid + '--list-btn'"
          class="btn"
          [attr.tabindex]="0"
          [attr.aria-haspopup]="true"
          [attr.aria-expanded]="false"
          [attr.aria-label]="'Close'"
          (click)="clear()"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </header>
      @if (userAccountData$ | async; as user) {
        <li class="my-account--item user" [attr.data-test]="node?.uid + '--list-item'">
          <div class="as-button" [attr.data-test]="node?.uid + '--user-name'">{{ user.name }}</div>
          @if (user.erpId) {
            <div
              class="as-button my-account--erp-id"
              [attr.data-test]="node?.uid + '--erp-id'"
            >{{ user.erpId }}
            </div>
          }
        </li>
      }
      @for (child of node?.children; track child.title) {
        <li
          class="my-account--item"
          [attr.data-test]="node?.uid + '-' + child?.uid + '--list-item'"
        >
          <cx-generic-link
            [attr.data-test]="node?.uid + '-' + child?.uid + '--list-item-link'"
            class="as-button"
            [url]="child.url"
            [target]="child.target"
            [style]="child.styleAttributes"
            [class]="child.styleClasses"
            (click)="closeIfClickedTheSameLink(child)"
          >
            {{ child.title }}
          </cx-generic-link>
        </li>
      }
    </ul>
  </nav>
}


